<template>
  <div class="my-invitation-box">
    <div class="invi-header">
      <div class="invi-title">我的邀请</div>
      <div class="invi-myinvi">
        <div class="invi-top-left invi-top">
          <svg-icon icon-class="myInvitation_sum"></svg-icon>
          <div>
            <div class="top-number">0</div>
            <div class="top-font">累计总数</div>
          </div>
        </div>
        <p class="invi-line"></p>
        <div class="invi-top-right invi-top">
          <svg-icon icon-class="myInvitation_verified"></svg-icon>
          <div>
            <div class="top-number">0</div>
            <div class="top-font">实名认证</div>
          </div>
        </div>
      </div>
    </div>
    <div class="invi-record">
      <div class="invi-title">邀请记录</div>
      <div class="invi-record-list">
        <div class="record-list-title">
          <p class="invi-account">账户</p>
          <p class="title-status">状态</p>
        </div>
        <div v-for="(item,index) in newData" :key="index" class="record-list-content">
          <p class="invi-account">{{item.phoneNo}}</p>
          <p class="title-status" :class="item.status=='已认证'?'status-verified':''">{{item.status}}</p>
        </div>
        <div class="null-status" v-if="dataList.length==0">
            <svg-icon icon-class="myInvitation_null"></svg-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataList: [
        { phone: '13045309080', status: '已认证' },
        { phone: '13045309080', status: '已认证' },
        { phone: '13045309080', status: '未认证' },
        { phone: '13045309080', status: '已认证' },
        { phone: '13045309080', status: '已认证' },
      ],
      newData:[]
    }
  },
  mounted() {
    this.getNewData()
  },
  methods: {
    getNewData() {
      this.dataList.map(x => {
        var newList = {}
        newList.phoneNo=x.phone.substr(0, 3) + "**" + x.phone.substr(8)
        newList.status=x.status  
        this.newData.push(newList) 
      })
    }
  }
}
</script>

<style lang="less" scoped>
.my-invitation-box {
  width: 375px;
  height: 100vh;
  background: #fffbf8;
  overflow: hidden;
  font-family: PingFang SC;
  .invi-header {
    width: 375px;
    height: 125px;
    margin-top: 10px;
    background: #ffffff;
    .invi-myinvi {
      width: 304px;
      margin: 18.5px auto 0 auto;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
    .invi-top {
      display: flex;
      .svg-icon {
        width: 38px;
        height: 38px;
      }
      .top-number,
      .top-font {
        margin-left: 17.5px;
      }
      .top-number {
        font-size: 16px;
        font-weight: bold;
        color: #b96700;
      }
      .top-font {
        font-size: 12px;
        font-weight: Medium;
        color: #666666;
      }
    }
    .invi-line {
      width: 0.5px;
      height: 25px;
      background: #ededed;
    }
  }
  .invi-title {
    width: 329px;
    height: 46px;
    line-height: 46px;
    margin: auto;
    font-size: 15px;
    font-weight: bold;
    border-bottom: 0.5px solid #ededed;
    color: #333333;
  }
  .invi-record {
    width: 375px;
    height: calc(100vh - 145px);
    margin-top: 10px;
    background: #ffffff;
      .custom-image .van-empty__image {
    width: 90px;
    height: 90px;
  }
    .invi-record-list {
      width: 329px;
      margin: auto;
      .null-status{
        text-align: center;
        margin-top: 90.5px;
        .svg-icon{
            width: 58px;
            height: 64px;
        }
      }
      .record-list-title {
        display: flex;
        margin: 11px 0 3px 0;
        font-size: 13px;
        font-weight: bold;
        color: #666666;
      }
      .title-status {
        margin-left: 144px;
      }
      .invi-account{
          width: 56px;
      }
      .record-list-content {
        display: flex;
        margin-top: 15px;
        font-weight: Regular;
        font-size: 12px;
        color: #999999;
        .status-verified {
          color: #facb90;
        }
      }
    }
  }
}
</style>